import { NgModule, LOCALE_ID, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeit from '@angular/common/locales/it';

import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { HttpErrorsInterceptor } from './shared/_interceptor/http-errors.interceptor';
import { MainModule } from './main/main.module';
import { SharedModule } from './shared/_service/shared.module';
import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/_guard/auth.guard';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './auth/_service/auth.service';
import * as Sentry from '@sentry/angular';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { LoadingComponent } from './main/_cms/loading/loading.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/');
}

registerLocaleData(localeit, 'it');

const routes: Routes = [{ path: '', redirectTo: '', pathMatch: 'full' }];

@NgModule({
	declarations: [AppComponent],
	imports: [
		CoreModule,
		SharedModule,
		AuthModule,
		MainModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		RouterModule.forRoot(routes),
		BrowserAnimationsModule,
		BlockUIModule.forRoot({
			template: LoadingComponent,
			delayStart: 500,
		}),
		BlockUIHttpModule.forRoot({
			//questa regex è usata per dire di non far comparire il loading per queste richieste
			requestFilters: [/noBlock/],
		}),
	],
	providers: [
		AuthGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpErrorsInterceptor,
			multi: true,
		},
		{
			provide: LOCALE_ID,
			deps: [AuthService],
			useFactory: (authService) => authService.getLocale(),
		},
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
